__turbopack_context__.v({
  "apply": "motivation-module__WucOlq__apply",
  "body": "motivation-module__WucOlq__body",
  "bullets": "motivation-module__WucOlq__bullets",
  "cause": "motivation-module__WucOlq__cause",
  "causeIcon": "motivation-module__WucOlq__causeIcon",
  "causeText": "motivation-module__WucOlq__causeText",
  "desc": "motivation-module__WucOlq__desc",
  "fadeIn": "motivation-module__WucOlq__fadeIn",
  "insetIn": "motivation-module__WucOlq__insetIn",
  "inside": "motivation-module__WucOlq__inside",
  "intervention": "motivation-module__WucOlq__intervention",
  "interventionText": "motivation-module__WucOlq__interventionText",
  "ninja": "motivation-module__WucOlq__ninja",
  "panel": "motivation-module__WucOlq__panel",
  "pillCover": "motivation-module__WucOlq__pillCover",
  "pillMuted": "motivation-module__WucOlq__pillMuted",
  "pillRing": "motivation-module__WucOlq__pillRing",
  "pulse": "motivation-module__WucOlq__pulse",
  "relight": "motivation-module__WucOlq__relight",
  "root": "motivation-module__WucOlq__root",
  "sonar": "motivation-module__WucOlq__sonar",
  "subhead": "motivation-module__WucOlq__subhead",
  "subheadLime": "motivation-module__WucOlq__subheadLime",
  "title": "motivation-module__WucOlq__title",
});
